"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../constants");

var defaultRollback = {
  type: _constants.DEFAULT_ROLLBACK
};
var _default = defaultRollback;
exports.default = _default;